export default "__VITE_ASSET__b234d32e__"